import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Alert,
  Snackbar,
  Button,
} from "@mui/material";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import DynamicTable from "../../../../Components/Common/DynamicTable";
import { validateTable } from "../../../../utils/validateTable";
import { restructureData } from "../../../../utils/restructureData";
import EastIcon from "@mui/icons-material/East";
import { put, api, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import SectionHeading from "../../GRI300/GRI308/SectionHeading";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI403_9 = ({ hide, downloadMode = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [data, setData] = useState({});
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const fields = [
    {
      id: 1,
      title:
        "i. The number and rate of fatalities as a result of work-related injury",
      text: ["No. of fatalities", "Rate of Fatalities", "Remark"],
      keys: ["fatalities", "rateOfFatalities", "remarkFatalities"],
      types: ["number", "number", "text"],
    },
    {
      id: 2,
      title:
        "ii. The number and rate of high-consequence work-related injuries (excluding fatalities)",
      text: [
        "No. of high-consequence work-related injuries",
        "Rate of high-consequence work-related injuries",
        "Remark",
      ],
      keys: [
        "highConsequenceInjuries",
        "rateOfHighConsequenceInjuries",
        "remarkHighConsequence",
      ],
      types: ["number", "number", "text"],
    },
    {
      id: 3,
      title: "iii. The number and rate of recordable work-related injuries",
      text: [
        "No. of recordable work-related injuries",
        "Rate of recordable work-related injuries",
        "Remark",
      ],
      keys: [
        "recordableInjuries",
        "rateOfRecordableInjuries",
        "remarkRecordable",
      ],
      types: ["number", "number", "text"],
    },
  ];

  const hoursfields = [
    {
      id: 1,
      title: "v. No of Hours Worked (in Hrs)",
      text: ["No of hours worked", "Remark"],
      keys: ["noOfHourWorked", "remarkHoured"],
      types: ["number", "text"],
    },
  ];

  const workplaceHoursfields = [
    {
      id: 1,
      title: "v. No of Hours Worked (in Hrs)",
      text: ["No of hours worked", "Remark"],
      keys: ["workplacenoOfHourWorked", "workplaceremarkHoured"],
      types: ["number", "text"],
    },
  ];

  const workplacefields = [
    {
      id: 1,
      title:
        "i. The number and rate of fatalities as a result of work-related injury",
      text: ["No. of fatalities", "Rate of Fatalities", "Remark"],
      keys: [
        "workplacefatalities",
        "workplacerateOfFatalities",
        "workplaceremarkFatalities",
      ],
      types: ["number", "number", "text"],
    },
    {
      id: 2,
      title:
        "ii. The number and rate of high-consequence work-related injuries (excluding fatalities)",
      text: [
        "No. of high-consequence work-related injuries",
        "Rate of high-consequence work-related injuries",
        "Remark",
      ],
      keys: [
        "workplacehighConsequenceInjuries",
        "workplacerateOfHighConsequenceInjuries",
        "workplaceremarkHighConsequence",
      ],
      types: ["number", "number", "text"],
    },
    {
      id: 3,
      title: "iii. The number and rate of recordable work-related injuries",
      text: [
        "No. of recordable work-related injuries",
        "Rate of recordable work-related injuries",
        "Remark",
      ],
      keys: [
        "workplacerecordableInjuries",
        "workplacerateOfRecordableInjuries",
        "workplaceremarkRecordable",
      ],
      types: ["number", "number", "text"],
    },
  ];

  const inputData = [
    {
      fieldName: "workRelated",
      title: "iv. The main types of work-related injury",
      fields: [
        {
          fieldName: "workRelatedInjury",
          title: "Type of work-related injury",
          type: "text",
          placeholder: "Type Here",
        },
      ],
    },
  ];

  const inputData1 = [
    {
      fieldName: "workRelated",
      title: "iv. The main types of work-related injury",
      fields: [
        {
          fieldName: "workRelatedInjury",
          title: "Type of work-related injury",
          type: "text",
          placeholder: "Type Here",
        },
      ],
    },
  ];

  const inputData2 = [
    {
      fieldName: "hierachyOfControls",
      title:
        "iii. Actions taken or underway to eliminate these hazards and minimiza risks using the hierarchy of controls",
      fields: [
        {
          fieldName: "action",
          title: "Action",
          type: "text",
          placeholder: "Type Here",
        },
      ],
    },
  ];

  const [tables, setTables] = React.useState([]);
  const [tabErrors, setTabErrors] = useState({});

  const [tables1, setTables1] = React.useState([]);
  const [tabErrors1, setTabErrors1] = useState({});

  const [tables2, setTables2] = React.useState([]);
  const [tabErrors2, setTabErrors2] = useState({});

  const [formData, setFormData] = useState({
    determined: "",
    highConsequence: "",
    hazardsAndMinizeRisk: "",
    wheatherTheRatesCalulated: "",
    workerExcluded: "",
    contextualInformation: "",
  });

  const [employeeData, setEmployeeData] = useState({
    fatalities: "",
    rateOfFatalities: "",
    remarkFatalities: "",
    highConsequenceInjuries: "",
    rateOfHighConsequenceInjuries: "",
    remarkHighConsequence: "",
    recordableInjuries: "",
    rateOfRecordableInjuries: "",
    remarkRecordable: "",
    noOfHourWorked: "",
    remarkHoured: "",
  });

  const [workplaceData, setWorkplaceData] = useState({
    workplacefatalities: "",
    workplacerateOfFatalities: "",
    workplaceremarkFatalities: "",
    workplacehighConsequenceInjuries: "",
    workplacerateOfHighConsequenceInjuries: "",
    workplaceremarkHighConsequence: "",
    workplacerecordableInjuries: "",
    workplacerateOfRecordableInjuries: "",
    workplaceremarkRecordable: "",
    workplacenoOfHourWorked: "",
    workplaceremarkHoured: "",
  });

  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleChange = (e, fieldKey) => {
    setEmployeeData((prevData) => ({
      ...prevData,
      [fieldKey]: e.target.value,
    }));
  };

  const handleChangeworkplace = (e, fieldKey) => {
    setWorkplaceData((prevData) => ({
      ...prevData,
      [fieldKey]: e.target.value,
    }));
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value, // Dynamically update the matching field
    }));
    console.log(`Field: ${name}, Value: ${value}`);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);

        const data1 = response.data.data.GRI400.workedRelatedInjury || {};
        setData(data1);
        setFormData({
          determined: data1?.workHazards?.determined || "",
          highConsequence: data1?.workHazards?.highConsequence || "",
          hazardsAndMinizeRisk: data1?.hazardsAndMinizeRisk || "",
          wheatherTheRatesCalulated: data1?.wheatherTheRatesCalulated
            ? "yes"
            : "no",
          workerExcluded: data1?.workerExcluded ? "yes" : "no",
          contextualInformation: data1?.contextualInformation || "",
        });
        setEmployeeData({
          fatalities: data1?.forAllEmployees?.fatalities || "",
          rateOfFatalities: data1?.forAllEmployees?.rateOfFatalities || "",
          remarkFatalities: data1?.forAllEmployees?.remarkFatalities || "",
          highConsequenceInjuries:
            data1?.forAllEmployees?.highConsequenceInjuries || "",
          rateOfHighConsequenceInjuries:
            data1?.forAllEmployees?.rateOfHighConsequenceInjuries || "",
          remarkHighConsequence:
            data1?.forAllEmployees?.remarkHighConsequence || "",
          recordableInjuries: data1?.forAllEmployees?.recordableInjuries || "",
          rateOfRecordableInjuries:
            data1?.forAllEmployees?.rateOfRecordableInjuries || "",
          remarkRecordable: data1?.forAllEmployees?.remarkRecordable || "",
          noOfHourWorked: data1?.forAllEmployees?.noOfHourWorked || "",
          remarkHoured: data1?.forAllEmployees?.remarkHoured || "",
        });
        setWorkplaceData({
          workplacefatalities:
            data1?.workplaceController?.workplacefatalities || "",
          workplacerateOfFatalities:
            data1?.workplaceController?.workplacerateOfFatalities || "",
          workplaceremarkFatalities:
            data1?.workplaceController?.workplaceremarkFatalities || "",
          workplacehighConsequenceInjuries:
            data1?.workplaceController?.workplacehighConsequenceInjuries || "",
          workplacerateOfHighConsequenceInjuries:
            data1?.workplaceController
              ?.workplacerateOfHighConsequenceInjuries || "",
          workplaceremarkHighConsequence:
            data1?.workplaceController?.workplaceremarkHighConsequence || "",
          workplacerecordableInjuries:
            data1?.workplaceController?.workplacerecordableInjuries || "",
          workplacerateOfRecordableInjuries:
            data1?.workplaceController?.workplacerateOfRecordableInjuries || "",
          workplaceremarkRecordable:
            data1?.workplaceController?.workplaceremarkRecordable || "",
          workplacenoOfHourWorked:
            data1?.workplaceController?.workplacenoOfHourWorked || "",
          workplaceremarkHoured:
            data1?.workplaceController?.workplaceremarkHoured || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async () => {
    if (!disabled) {
      const isTableValid = validateTable(inputData, tables, setTabErrors);
      const isTableValid1 = validateTable(inputData1, tables1, setTabErrors1);
      const isTableValid2 = validateTable(inputData2, tables2, setTabErrors2);

      // if (!isTableValid || !isTableValid1 || !isTableValid2) {
      //   return;
      // }

      let transformedData = restructureData(tables);
      let transformedData1 = restructureData(tables1);
      let transformedData2 = restructureData(tables2);

      const payload = {
        type: "GRI400",
        submitted403_9: true,
        workedRelatedInjury: {
          forAllEmployees: {
            ...employeeData,
            ...transformedData,
          },
          workplaceController: {
            ...workplaceData,
            ...transformedData1,
          },
          workHazards: {
            determined: formData.determined,
            highConsequence: formData.highConsequence,
            ...transformedData2,
          },
          hazardsAndMinizeRisk: formData.hazardsAndMinizeRisk,
          wheatherTheRatesCalulated: formData.wheatherTheRatesCalulated,
          workerExcluded: formData.workerExcluded,
          contextualInformation: formData.contextualInformation,
        },
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`${api}/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/403-10/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/403-10/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && (
        <p className={styles.section_heading}>
          403 : Occupational Health and Safety
        </p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        403-9 : Work-related injuries
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <SectionHeading
          text="a. For all employees"
          sx={{ marginBottom: "-0.5rem" }}
        />
        {fields.map((field) => (
          <Box key={field.id} sx={{ mb: 1, marginLeft: "1rem", width: "97%" }}>
            <p variant="subtitle1" className={styles.ques_heading}>
              {field.title}
            </p>
            <Grid container spacing={2} sx={{ marginLeft: "0.2rem" }}>
              {field.text.map((text, index) => (
                <Grid item xs={12} sm={index === 2 ? 3.2 : 4.4} key={index}>
                  <p style={{ fontSize: "14px", marginTop: "-0.5rem" }}>
                    {text}
                  </p>
                  <TextField
                    fullWidth
                    placeholder="Type here"
                    variant="outlined"
                    type={field.types[index]} // Set input type
                    sx={{
                      marginTop: "-0.5rem",
                      "& .MuiOutlinedInput-root": {
                        height: "2.5rem",
                      },
                      "& input[type=number]": {
                        MozAppearance: "textfield",
                      },
                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                    }}
                    // onChange={(e) => handleChange(e, field.keys[index])}
                    value={employeeData[field.keys[index]] || ""}
                    onChange={(e) => handleChange(e, field.keys[index])}
                    onKeyPress={(e) => {
                      if (
                        field.types[index] === "number" &&
                        (e.key === "-" || e.key === "e")
                      ) {
                        e.preventDefault(); // Prevent negative and exponential input
                      }
                    }}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      onWheel: (e) => e.target.blur(), // Prevent scrolling from changing the value
                    }}
                    disabled={disabled}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
      </Box>

      <Box sx={{ marginLeft: "1rem", marginTop: "-1.2rem" }}>
        <DynamicTable
          inputData={inputData}
          tables={tables}
          disabled={disabled}
          setTables={setTables}
          data={data?.forAllEmployees}
          errors={tabErrors}
          setErrors={setTabErrors}
          hide={hide}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginLeft: "1rem",
          marginTop: "-1.5rem",
        }}
      >
        {hoursfields.map((field) => (
          <Box key={field.id}>
            <p variant="subtitle1" className={styles.ques_heading}>
              {field.title}
            </p>
            <Grid container spacing={2} sx={{ marginLeft: "0.2rem" }}>
              {field.text.map((text, index) => (
                <Grid item xs={12} sm={index === 2 ? 3.4 : 4.3} key={index}>
                  <p style={{ fontSize: "14px", marginTop: "-0.5rem" }}>
                    {text}
                  </p>
                  <TextField
                    fullWidth
                    placeholder="Type here"
                    variant="outlined"
                    disabled={disabled}
                    type={field.types[index]} // Set input type
                    sx={{
                      marginTop: "-0.5rem",
                      "& .MuiOutlinedInput-root": {
                        height: "2.5rem",
                      },
                      "& input[type=number]": {
                        MozAppearance: "textfield",
                      },
                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                    }}
                    value={employeeData[field.keys[index]] || ""}
                    onChange={(e) => handleChange(e, field.keys[index])}
                    onKeyPress={(e) => {
                      if (
                        field.types[index] === "number" &&
                        (e.key === "-" || e.key === "e")
                      ) {
                        e.preventDefault(); // Prevent negative and exponential input
                      }
                    }}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      onWheel: (e) => e.target.blur(), // Prevent scrolling from changing the value
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
      </Box>

      {/* section B */}
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <SectionHeading
          text="b. For all workers who are not employees but whose work and/or workplace is controlled by the organization"
          sx={{ marginBottom: "-0.5rem" }}
        />
        {workplacefields.map((field) => (
          <Box
            key={field.id}
            sx={{ mb: 1, marginLeft: "1.2rem", width: "97%" }}
          >
            <p variant="subtitle1" className={styles.ques_heading}>
              {field.title}
            </p>
            <Grid container spacing={2} sx={{ marginLeft: "0.2rem" }}>
              {field.text.map((text, index) => (
                // <Grid item xs={12} sm={index === 2 ? 3.4 : 4.3} key={index}>
                <Grid item xs={12} sm={index === 2 ? 3.2 : 4.4} key={index}>
                  <p style={{ fontSize: "14px", marginTop: "-0.5rem" }}>
                    {text}
                  </p>
                  <TextField
                    fullWidth
                    placeholder="Type here"
                    variant="outlined"
                    disabled={disabled}
                    type={field.types[index]} // Set input type
                    sx={{
                      marginTop: "-0.5rem",
                      "& .MuiOutlinedInput-root": {
                        height: "2.5rem",
                      },
                      "& input[type=number]": {
                        MozAppearance: "textfield", // Removes spinner in Firefox
                      },
                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none", // Removes spinner in Chrome/Safari
                          margin: 0,
                        },
                    }}
                    value={workplaceData[field.keys[index]] || ""}
                    onChange={(e) =>
                      handleChangeworkplace(e, field.keys[index])
                    }
                    onKeyPress={(e) => {
                      if (
                        field.types[index] === "number" &&
                        (e.key === "-" || e.key === "e")
                      ) {
                        e.preventDefault(); // Prevent negative and exponential input
                      }
                    }}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      onWheel: (e) => e.target.blur(), // Prevent scrolling from changing the value
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
      </Box>

      <Box sx={{ marginLeft: "1rem" }}>
        <DynamicTable
          inputData={inputData1}
          tables={tables1}
          setTables={setTables1}
          disabled={disabled}
          data={data?.workplaceController}
          errors={tabErrors1}
          setErrors={setTabErrors1}
          hide={hide}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginLeft: "1rem",
          marginTop: "-1.5rem",
        }}
      >
        {workplaceHoursfields.map((field) => (
          <Box key={field.id} sx={{ mb: 3 }}>
            <p variant="subtitle1" className={styles.ques_heading}>
              {field.title}
            </p>
            <Grid container spacing={2} sx={{ marginLeft: "0.2rem" }}>
              {field.text.map((text, index) => (
                <Grid item xs={12} sm={index === 2 ? 3.4 : 4.3} key={index}>
                  <p style={{ fontSize: "14px", marginTop: "-0.5rem" }}>
                    {text}
                  </p>
                  <TextField
                    fullWidth
                    placeholder="Type here"
                    variant="outlined"
                    disabled={disabled}
                    type={field.types[index]} // Set input type
                    sx={{
                      marginTop: "-0.5rem",
                      "& .MuiOutlinedInput-root": {
                        height: "2.5rem",
                      },
                      "& input[type=number]": {
                        MozAppearance: "textfield", // Removes spinner in Firefox
                      },
                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none", // Removes spinner in Chrome/Safari
                          margin: 0,
                        },
                    }}
                    value={workplaceData[field.keys[index]] || ""}
                    onChange={(e) =>
                      handleChangeworkplace(e, field.keys[index])
                    }
                    onKeyPress={(e) => {
                      if (
                        field.types[index] === "number" &&
                        (e.key === "-" || e.key === "e")
                      ) {
                        e.preventDefault(); // Prevent negative and exponential input
                      }
                    }}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      onWheel: (e) => e.target.blur(), // Prevent scrolling from changing the value
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
      </Box>

      {/* SectionC */}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box>
        <SectionHeading
          text="c. The work-related hazards that pose a risk of high-consequence injury including:"
          sx={{ marginBottom: "-0.1rem" }}
        />
        <Box sx={{ marginBottom: "2rem", width: "97%" }}>
          <SectionHeading
            text="i. How these hazards have been determined"
            sx={{ marginLeft: "1.2rem" }}
          />
          <TextField
            fullWidth
            placeholder="Type Here"
            variant="outlined"
            disabled={disabled}
            multiline
            minRows={1}
            sx={{
              marginLeft: "2rem",
              marginTop: "-0.5rem",
              "& .MuiOutlinedInput-root": {
                padding: "10px",
                display: "flex", // Ensures proper alignment
              },
              "& .MuiInputBase-root": {
                overflow: "hidden", // Prevents text from overflowing
              },
              "& textarea": {
                resize: "none", // Prevents manual resizing to keep it controlled
              },
            }}
            value={formData.determined}
            name="determined"
            onChange={handleFieldChange}
          />
        </Box>

        <SectionHeading
          text="ii. Which of these hazards have caused or contributed to high-consequence injuries during the reporting period"
          sx={{ marginLeft: "1.2rem" }}
        />
        <TextField
          fullWidth
          placeholder="Type Here"
          variant="outlined"
          multiline
          minRows={1}
          disabled={disabled}
          sx={{
            marginLeft: "2rem",
            marginTop: "-0.5rem",
            width: "97%",
            "& .MuiOutlinedInput-root": {
              padding: "10px",
              display: "flex", // Ensures proper alignment
            },
            "& .MuiInputBase-root": {
              overflow: "hidden", // Prevents text from overflowing
            },
            "& textarea": {
              resize: "none", // Prevents manual resizing to keep it controlled
            },
          }}
          value={formData.highConsequence}
          name="highConsequence"
          onChange={handleFieldChange}
        />

        <Box sx={{ marginLeft: "1rem" }}>
          <DynamicTable
            inputData={inputData2}
            tables={tables2}
            setTables={setTables2}
            data={data?.workHazards}
            disabled={disabled}
            errors={tabErrors2}
            setErrors={setTabErrors2}
            hide={hide}
          />
        </Box>
      </Box>

      {/* D,E,F,G */}
      <Box>
        {/* Question D */}
        <Box sx={{ marginTop: "-0.5rem" }}>
          <SectionHeading
            text="d. Any actions taken or underway to eliminate other work-related hazards and minimize risks
          using the hierarchy of controls."
          />
          <TextField
            fullWidth
            placeholder="Type Here"
            variant="outlined"
            multiline
            minRows={1}
            disabled={disabled}
            sx={{
              width: "98%",
              marginLeft: "1rem",
              marginTop: "-0.5rem",
              "& .MuiOutlinedInput-root": {
                padding: "10px",
                display: "flex", // Ensures proper alignment
              },
              "& .MuiInputBase-root": {
                overflow: "hidden", // Prevents text from overflowing
              },
              "& textarea": {
                resize: "none", // Prevents manual resizing to keep it controlled
              },
            }}
            value={formData.hazardsAndMinizeRisk}
            name="hazardsAndMinizeRisk"
            onChange={handleFieldChange}
          />
        </Box>

        {/* Question E */}
        <Box>
          <FormControl>
            <SectionHeading
              text="e. Whether the rates have been calculated based on 200,000 or 1,000,000 hours worked."
              sx={{ marginBottom: "-0.1rem" }}
            />
            <RadioGroup
              row
              name="wheatherTheRatesCalulated"
              value={formData.wheatherTheRatesCalulated}
              onChange={handleFieldChange}
              sx={{ marginLeft: "1rem" }}
              disabled={disabled}
            >
              <FormControlLabel
                value="yes"
                control={<Radio disabled={disabled} />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={<Radio disabled={disabled} />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
        </Box>

        {/* Question F */}
        <Box>
          <FormControl>
            <SectionHeading
              text="f. Whether and, if so, why any workers have been excluded from this disclosure, including
            the types of worker excluded."
              sx={{ marginBottom: "-0.1rem" }}
            />
            <RadioGroup
              row
              onChange={handleFieldChange}
              name="workerExcluded"
              value={formData.workerExcluded}
              sx={{ marginLeft: "1rem" }}
              disabled={disabled}
            >
              <FormControlLabel
                value="yes"
                control={<Radio disabled={disabled} />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={<Radio disabled={disabled} />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
        </Box>

        {/* Question G */}
        <Box>
          <SectionHeading text="g. Any contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used." />
          <TextField
            fullWidth
            placeholder="Type Here"
            name="contextualInformation"
            variant="outlined"
            value={formData.contextualInformation}
            multiline
            minRows={1}
            disabled={disabled}
            sx={{
              width: "98%",
              marginLeft: "1rem",
              marginTop: "-0.5rem",
              "& .MuiOutlinedInput-root": {
                padding: "10px",
                display: "flex", // Ensures proper alignment
              },
              "& .MuiInputBase-root": {
                overflow: "hidden", // Prevents text from overflowing
              },
              "& textarea": {
                resize: "none", // Prevents manual resizing to keep it controlled
              },
            }}
            onChange={handleFieldChange}
          />
        </Box>

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI403_9;
